module.exports = __webpack_public_path__ + "img/757.7147d769.jpg";